import { InputFormTypeTel } from "../../mod.ts";
import { InputFormTypeAllType } from "../../../types.ts";
import { InputItemType } from "@config/app/questionTemplates/types.ts";

export const InputPhone = (
  {
    value,
    data: {
      id,
      label,
      placeholder,
      required,
      disabled,
    },
    onError,
    onSuccess,
    lastCheckedAt = 0,
  }: InputFormTypeAllType<{
    data: InputItemType;
  }>,
) => {
  return (
    <InputFormTypeTel
      onSuccess={onSuccess}
      onError={onError}
      id={id}
      label={label}
      placeholder={placeholder}
      value={value}
      isRequired={required}
      isDisabled={disabled}
      lastCheckedAt={lastCheckedAt}
    />
  );
};
